import { useState } from "react";

const FunnelCard = ({ icon, tag, title, text }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const shortText = text.split(" ").slice(0, 30).join(" ");

  return (
    <div className="funnel-card">
      <div className="funnel-icon"><img src={icon} alt={title} /></div>
      <h3>{title}</h3>

      <p>
        {isExpanded ? text : `${shortText}...`}
      </p>

      <button
        className="read-toggle"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
};

export default FunnelCard;